import { connect } from "react-redux";

import { getSPParticipantsListRequest } from "store/actions/sp.actions";
import { getParticipantsList, getSpSetting } from "store/selector/sp.selector";

import KYPReports from "./KYPReports";

const mapDispatchToProps = {
  getParticipantList: getSPParticipantsListRequest,
};

const mapStateToProps = (state) => {
  const spParticipants = getParticipantsList(state);
  const settings = getSpSetting(state);
  return { spParticipants, settings };
};

export default connect(mapStateToProps, mapDispatchToProps)(KYPReports);
